import { PayloadAction } from "@reduxjs/toolkit";
import { UserPermissions } from 'entities/user';

import { IState } from "../types/state";

const setPermissions = (state: IState, action: PayloadAction<UserPermissions>) => {
    state.permissions.data = action.payload;
}

export default setPermissions;
